import api from './api';

const BASE = '/design-studio';

const designCommentService = {
  createComment: async (projectId, { x, y, text, author, fileId }) => {
    const response = await api.post(`${BASE}/projects/${projectId}/comments`, {
      x, y, text, author, fileId,
    });
    return response.data.data;
  },

  listComments: async (projectId) => {
    const response = await api.get(`${BASE}/projects/${projectId}/comments`);
    return response.data.data;
  },

  updateComment: async (commentId, data) => {
    const response = await api.put(`${BASE}/comments/${commentId}`, data);
    return response.data.data;
  },

  deleteComment: async (commentId) => {
    const response = await api.delete(`${BASE}/comments/${commentId}`);
    return response.data;
  },

  addReply: async (commentId, text, author = 'User') => {
    const response = await api.post(`${BASE}/comments/${commentId}/replies`, { text, author });
    return response.data.data;
  },

  /**
   * Stream Claude's response to a comment. Returns { events: async generator, cancel }.
   * Same pattern as designStudioService.generateDesign.
   */
  sendToClaude: (commentId) => {
    const token = localStorage.getItem('token');
    const port = process.env.REACT_APP_API_PORT || '8003';
    const baseURL = process.env.REACT_APP_API_URL || `http://localhost:${port}/api`;
    const url = `${baseURL}${BASE}/comments/${commentId}/send-to-claude`;

    const abortController = new AbortController();

    const events = async function* () {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          Accept: 'text/event-stream',
          'Cache-Control': 'no-cache',
        },
        signal: abortController.signal,
      });

      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.detail || `HTTP ${response.status}`);
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        const chunk = decoder.decode(value, { stream: true });
        for (const line of chunk.split('\n')) {
          if (!line.startsWith('data: ')) continue;
          const raw = line.slice(6).trim();
          if (!raw) continue;
          try { yield JSON.parse(raw); } catch { /* skip malformed */ }
        }
      }
    };

    return { events, cancel: () => abortController.abort() };
  },
};

export default designCommentService;
